const normalizeWhitespace = (value = "") => value.replace(/\s+/g, " ").trim();

const toSentence = (value = "") => {
  const text = normalizeWhitespace(value);
  if (!text) return "";
  return /[.!?]$/.test(text) ? text : `${text}.`;
};

const splitNumberedItems = (value = "") => {
  const text = normalizeWhitespace(value);
  if (!text) return [];
  const matches = [...text.matchAll(/(\d+)\)\s*/g)];
  if (matches.length === 0) return [];

  return matches
    .map((match, index) => {
      const start = match.index + match[0].length;
      const end = index + 1 < matches.length ? matches[index + 1].index : text.length;
      return toSentence(text.slice(start, end));
    })
    .filter(Boolean);
};

const toTitleCase = (value = "") =>
  value
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());

const normalizePhotoRange = (value = "") => value.replace(/(\d+)\s*-\s*(\d+)/g, "$1-$2");

const buildSectionTitle = (label, markerText) => {
  const photosMatch = markerText.match(/\(photos?[^)]*\)/i);
  if (!photosMatch) return label;
  const cleanPhotos = toTitleCase(normalizePhotoRange(photosMatch[0]));
  return `${label} ${cleanPhotos}:`;
};

// Converts long free-form comment text into presentable sections when possible.
export const formatAuditComment = (raw = "") => {
  const normalized = normalizeWhitespace(raw);
  if (!normalized) {
    return { intro: "", sections: [], fallbackText: "" };
  }

  const positiveMarker =
    /(several\s+positive\s+observations[^:]*\(photos?[^)]*\)\s*:?)/i;
  const improvementMarker =
    /(a\s+few\s+noted\s+(?:rooms?|areas?)\s+for\s+improvement[^:]*\(photos?[^)]*\)\s*:?)/i;

  const positiveMatch = normalized.match(positiveMarker);
  const improvementMatch = normalized.match(improvementMarker);

  if (!positiveMatch || !improvementMatch) {
    return { intro: "", sections: [], fallbackText: raw };
  }

  const introRaw = normalized.slice(0, positiveMatch.index);
  const positiveStart = positiveMatch.index + positiveMatch[0].length;
  const improvementStart = improvementMatch.index + improvementMatch[0].length;
  const positiveRaw = normalized.slice(positiveStart, improvementMatch.index);
  const improvementRaw = normalized.slice(improvementStart);

  const positiveItems = splitNumberedItems(positiveRaw);
  const improvementItems = splitNumberedItems(improvementRaw);
  if (positiveItems.length === 0 && improvementItems.length === 0) {
    return { intro: "", sections: [], fallbackText: raw };
  }

  const intro = toSentence(introRaw);
  const sections = [];
  if (positiveItems.length > 0) {
    sections.push({
      title: buildSectionTitle("Positive observations", positiveMatch[0]),
      items: positiveItems,
    });
  }
  if (improvementItems.length > 0) {
    sections.push({
      title: buildSectionTitle("Areas for improvement", improvementMatch[0]),
      items: improvementItems,
    });
  }

  return { intro, sections, fallbackText: raw };
};
